import { Injectable } from '@angular/core';
import { CanDeactivate, Router } from '@angular/router';

import { AbandonedCartModalComponent } from '../abandoned-cart-modal/abandoned-cart-modal.component';

@Injectable({
  providedIn: 'root',
})
export class AbandonCartGuard
  implements CanDeactivate<AbandonedCartModalComponent>
{
  private allowDeactivate = false;
  public allowRouteException = false;

  constructor(protected router: Router) {}

  public canDeactivate(): boolean {
    return this.allowDeactivate;
  }

  public setDeactivate(canDeactivate: boolean): void {
    this.allowDeactivate = canDeactivate;
  }

  public setAllowRouteException(allowRouteException: boolean): void {
    this.allowRouteException = allowRouteException;
  }
}
